var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "page-header",
        {
          attrs: {
            title: _vm.$t("pages.notifications.title"),
            "icon-class": "mdi mdi-bell-outline"
          }
        },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-outline-dark btn-sm float-right mb-4",
              on: { click: _vm.markAllAsRead }
            },
            [
              _c("i", { staticClass: "mdi mdi-checkbox-marked-outline" }),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("pages.notifications.mark_all_read")) +
                  "\n        "
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      !_vm.notifications.length
        ? _c("div", { staticClass: "alert alert-light" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("pages.notifications.no_notifications")) +
                "\n    "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.notifications.length
        ? _c(
            "div",
            _vm._l(_vm.notifications, function(notification) {
              return _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 grid-margin" }, [
                  _c(
                    "div",
                    {
                      staticClass: "card",
                      class: {
                        "notification-read": _vm.isNotificationRead(
                          notification
                        )
                      }
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-1" }, [
                            _c(
                              "div",
                              { staticClass: "notification-thumbnail mb-2" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "preview-icon",
                                    class: notification.data.meta.type
                                  },
                                  [
                                    _c("i", {
                                      class: notification.data.meta.icon
                                    })
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-9" }, [
                            _c("h5", { staticClass: "card-title" }, [
                              _vm._v(_vm._s(notification.data.title))
                            ]),
                            _vm._v(" "),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(notification.data.text)
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-2 text-right" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm
                                    .$date(notification.created_at)
                                    .format("LLL")
                                ) +
                                "\n                            "
                            )
                          ])
                        ])
                      ])
                    ]
                  )
                ])
              ])
            }),
            0
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }